import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import AOS from 'aos'

import Header from './Header'
import Footer from './Footer'

import 'aos/dist/aos.css'
import '../sass/index.scss'

import opengraph from '../images/gain-og.png'
import faviconPNG from '../images/favicon.png'

function Layout({ title, description, headerMode, children }) {
	const {
		site: { siteMetadata },
	} = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						siteUrl
						keywords
						author
					}
				}
			}
		`
	)

	const siteTitle = title || siteMetadata.title
	const metaDescription = description || siteMetadata.description
	const { siteUrl, keywords } = siteMetadata

	useEffect(() => {
		AOS.init({
			disable: () => window && window.innerWidth <= 780,
			offset: 100, // offset (in px) from the original trigger point
			delay: 200, // values from 0 to 3000, with step 50ms
			duration: 800, // values from 0 to 3000, with step 50ms
			easing: 'ease-in-out', // default easing for AOS animations
			once: false, // whether animation should happen only once - while scrolling down
			mirror: false, // whether elements should animate out while scrolling past them
			anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
		})
		// eslint-disable-next-line
	}, [])

	return (
		<>
			<Helmet
				title={siteTitle}
				titleTemplate={title ? `%s | ${siteMetadata.title}` : siteMetadata.title}
				meta={[
					{
						property: 'og:image',
						content: opengraph || '',
					},
					{
						name: 'twitter:image',
						content: opengraph || '',
					},
					{
						name: 'description',
						content: metaDescription,
					},
					{
						property: 'og:description',
						content: metaDescription,
					},
					{
						name: 'twitter:description',
						content: metaDescription,
					},
					{
						property: 'og:title',
						content: siteTitle,
					},
					{
						name: 'twitter:title',
						content: siteTitle,
					},
					{
						property: 'og:url',
						content: siteUrl,
					},
					{
						name: 'twitter:site',
						content: siteUrl,
					},
					{
						property: 'og:type',
						content: 'Website',
					},
					{
						name: 'twitter:card',
						content: 'summary_large_image',
					},
					{
						name: 'keywords',
						content: keywords,
					},
				]}
				link={[
					{
						href: faviconPNG,
						rel: 'shortcut icon',
						type: 'image/png',
						sizes: '32x32 192x192',
					},
				]}
			/>
			<Header headerMode={headerMode} />
			<main>{children}</main>
			<Footer />
		</>
	)
}

Layout.propTypes = {
	title: PropTypes.string,
	meta: PropTypes.array,
	children: PropTypes.node.isRequired,
}

export default Layout
